<!-- Loading bar -->
<fuse-loading-bar></fuse-loading-bar>

<!-- Navigation -->
<fuse-vertical-navigation
    class="bg-gray-900 dark dark:bg-primary-900 print:hidden"
    [appearance]="navigationAppearance"
    [mode]="isScreenSmall ? 'over' : 'side'"
    [name]="'mainNavigation'"
    [navigation]="navigation.default"
    [opened]="!isScreenSmall"
>
    <!-- Navigation header hook -->
    <ng-container fuseVerticalNavigationContentHeader>
        <!-- Logo -->
        <div class="flex items-center justify-center h-20">
            <img
                class="w-8"
                src="assets/images/logo/agritrack-icon.png"
                alt="Agritrack logo image"
            />
        </div>
    </ng-container>
</fuse-vertical-navigation>

<!-- Wrapper -->
<div class="flex flex-col flex-auto w-full min-w-0">
    <!-- Header -->
    <div
        class="relative flex items-center w-full h-16 px-4 shadow flex-0 md:px-6 z-49 dark:shadow-none dark:border-b border-primary dark:border-accent dark:border-opacity-50 bg-card dark:bg-primary-900 print:hidden"
    >
        <div class="flex items-center pr-2 space-x-2">
            <!-- Navigation toggle button -->
            <button
                mat-icon-button
                (click)="toggleNavigation('mainNavigation')"
            >
                <mat-icon [svgIcon]="'heroicons_outline:menu'"></mat-icon>
            </button>
            <!-- Navigation appearance toggle button -->
            <button
                class="hidden md:inline-flex"
                mat-icon-button
                (click)="toggleNavigationAppearance()"
            >
                <mat-icon
                    [svgIcon]="'heroicons_outline:switch-horizontal'"
                ></mat-icon>
            </button>
        </div>

        <!-- Display filters -->
        <div
            class="flex-col items-center justify-start hidden min-w-0 gap-0 mx-auto my-0 overflow-hidden leading-4 grow shrink basis-0 sm:flex md:flex lg:flex xl:flex 2xl:flex"
        >
            <ng-container *ngIf="filterNotification | async as filter">
                <ng-container *ngIf="activeFilters | async as active">
                    <div class="leading-4 min-w-max">
                        <div
                            *ngIf="active.from"
                            [ngClass]="
                                filter.from
                                    ? 'text-agriGreen-700 text-bold text-base'
                                    : 'text-secondary text-normal text-sm'
                            "
                        >
                            From: {{ filter.from | date : "dd/MM/YYYY" || "" }},
                        </div>
                        <div
                            *ngIf="active.to"
                            [ngClass]="
                                filter.to
                                    ? 'text-agriGreen-700 text-bold text-base'
                                    : 'text-secondary text-normal text-sm'
                            "
                        >
                            To: {{ filter.to | date : "dd/MM/YYYY" || "" }}
                        </div>
                    </div>
                    <div class="max-w-full">
                        <div
                            *ngIf="active.site"
                            [ngClass]="
                                filter?.cfms_site?.length > 0
                                    ? 'text-agriGreen-700 text-bold text-base truncate'
                                    : 'text-secondary text-normal text-sm truncate'
                            "
                        >
                            Sites: {{ filter?.cfms_site?.toString() || "" }}
                        </div>
                        <!-- <div *ngIf="active.site" [ngClass]=" filter?.site?.length > 0 ? 'text-agriGreen-700 text-bold text-base truncate' : 'text-secondary text-normal text-sm truncate' ">Sites: {{getSiteCodes(filter?.site)}}</div> -->
                    </div>
                </ng-container>
            </ng-container>
        </div>

        <!-- Components -->
        <div class="flex items-center pl-2 ml-auto space-x-0.5 sm:space-x-2">
            <ng-container *ngIf="filterNotification | async as filter">
                <div>
                    <button
                        mat-icon-button
                        [matMenuTriggerFor]="menu"
                        aria-label="Filters"
                    >
                        <mat-icon
                            [ngClass]="
                                filter.from ||
                                filter.to ||
                                filter.site?.length > 0
                                    ? 'text-agriGreen-700'
                                    : ''
                            "
                            [svgIcon]="'heroicons_solid:magnifying'"
                            class="font-semibold"
                        ></mat-icon>
                    </button>
                    <mat-menu
                        #menu="matMenu"
                        class="absolute top-0 right-0 p-3"
                    >
                        <filters
                            [farmFilter]="showFarm"
                            [dateFilter]="showDate"
                        ></filters>
                    </mat-menu>
                </div>
            </ng-container>

            <bell-notif></bell-notif>
            <languages></languages>
            <fuse-fullscreen class="hidden md:block"></fuse-fullscreen>
            <!-- <user></user> -->
            <settings></settings>
            <img
                class="h-8"
                src="assets/images/logo/avis-logo.webp"
                alt="Avis logo"
            />
        </div>
    </div>

    <!-- Content -->
    <div
        class="relative flex flex-col flex-auto dark:bg-primary-800 dark:bg-opacity-60"
    >
        <!-- ngIf=true hack is required here for router-outlet to work correctly.
             Otherwise, layout changes won't be registered and the view won't be updated! -->
        <app-loading-overlay></app-loading-overlay>
        <router-outlet *ngIf="true"></router-outlet>
    </div>

    <!-- Footer -->
    <div
        class="relative flex items-center justify-end w-full px-4 border-t dark:border-opacity-50 flex-0 h-14 md:px-6 bg-card dark:border-accent dark:bg-primary-900 print:hidden"
    >
        <span class="font-medium text-secondary"
            >Agritrack &copy; {{ currentYear }}</span
        >
    </div>
</div>
